<template>
    <ScrollableTable ref="scroll" class="card-table-container" @scroll="onScroll" v-loading="marketPolling && initializing && !list.length" element-loading-background="var(--theme-bg)">
        <div class="board-table-content">
            <div class="card-table-header flex height-31">
                <div class="flex-1" style="max-width: 50px">序号</div>
                <div class="flex-1">代码</div>
                <div class="flex-1">名称</div>
                <div class="flex-1">最新价</div>
                <div class="flex-1">涨跌额</div>
                <div class="flex-1">涨跌幅</div>
                <div class="flex-1">成交额(万元)</div>
                <div class="flex-1">振幅(%)</div>
                <div class="flex-1">市盈率(TTM)</div>
                <div class="flex-1">市净率</div>
                <div class="flex-1">量比</div>
                <div class="flex-1">委比(%)</div>
                <div class="flex-1">总股本(万)</div>
                <div class="flex-1">流通股本(万)</div>
                <div class="flex-1">总市值(亿元)</div>
                <div class="flex-1">流通市值(亿元)</div>
            </div>
             <ul class="card-table-body">
                <li class="flex height-31" v-for="(v,idx) in sharedStockRows(list, 'cn')" @click="childMethod(v.full_code)" :key="idx">
                    <div class="flex-1 nowrap" style="max-width: 50px">{{ idx+1 }}</div>
                  <div class="flex-1">{{ v.code }}</div>
                  <div class="flex-1">{{ v.name }}</div>
                  <div class="flex-1">{{ price(v.last_px) }}</div>
                  <div :class="changeClass(v.px_change)">{{ price(v.px_change) }}</div>
                  <div :class="changeClass(v.px_change_rate)">{{ percent(v.px_change_rate) }}</div>
                  <div class="flex-1">{{ display(v.business_balance) }}</div>
                  <div class="flex-1">{{ percent(v.amplitude) }}</div>
                  <div class="flex-1">{{ display(v.pe_rate) }}</div>
                  <div class="flex-1">{{ display(v.market_rate) }}</div>
                  <div class="flex-1">{{ display(v.lb) }}</div>
                  <div :class="changeClass(v.wb)">{{ percent(v.wb) }}</div>
                  <div class="flex-1">{{ display(v.total_stock) }}</div>
                  <div class="flex-1">{{ display(v.total_mstock) }}</div>
                  <div class="flex-1">{{ display(v.total_value) }}</div>
                  <div class="flex-1">{{ display(v.circulation_value) }}</div>
                </li>
            </ul>
            <div v-if="loadError" class="text-align_center" role="alert">加载失败 <button type="button" @click="init">重试</button></div>
            <div v-else-if="!initializing && !list.length" class="text-align_center">暂无数据</div>
        </div>
    </ScrollableTable>
</template>

<script>
import { quotePercent, quoteDisplay, quotePrice } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import { quoteTone } from '@/utils/quoteColors'
    import {apiStockListByCate} from "@/utils/requestapis";
    import { pollMarket, refreshChinaStocks } from '@/utils/marketRefresh'
    import ScrollableTable from '@/components/ScrollableTable.vue'

    export default {
      name: "BoardTable",
      components: { ScrollableTable },
      props: { marketPolling: { type: Boolean, default: false }, categoryId: { type: Number, default: 1 } },
      // props: {
      //   cate_id:{
      //     type: Number,
      //     default: 1
      //   }
      // },
      data(){
        return {
          submitInfo:{
            page:1,
            page_size:50,
            cate_id:this.categoryId
          },
          list:[],
          initializing:false,
          loadError:false,
          requestId:0,
          loading:true,
          loaded:false,
          refreshing:false,
        }
      },
      watch: { marketPolling(active) { if (active) this.activate(); else this.stopPolling() } },
      mounted() { if (this.marketPolling) this.activate() },
      beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
      methods: {
        sharedStockRows,
        price: quotePrice,
        display: quoteDisplay,
    percent: quotePercent,
        stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
        async activate() {
          if (this.disposed || !this.marketPolling || this.stopRefresh) return
          try {
            if (this.loaded && this.list.length) await this.refreshMarket()
            else await this.init()
          } finally {
            if (!this.disposed && this.marketPolling && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.refreshMarket(), 'cn')
          }
        },
        async refreshMarket() {
          if (this.disposed || !this.marketPolling || this.initializing || this.refreshing || !this.list.length) return
          this.refreshing = true
          try {
            const category = this.submitInfo.cate_id
            const updates = new Map((await refreshChinaStocks(this.list)).map(item => [item.full_code, item]))
            if (this.disposed || category !== this.submitInfo.cate_id) return
            this.list = this.list.map(item => updates.get(item.full_code) || item)
          } catch (_) { /* Keep cached quotes; retry on the next active polling cycle. */ }
          finally { this.refreshing = false }
        },
        childMethod(code) {
          this.$nextTick(() => {
            this.$emit('board-table-click', code)
          });
          
        },
        async init(){
          if (this.disposed || !this.marketPolling || this.initializing) return
          const requestId = ++this.requestId
          const params = { ...this.submitInfo }
          this.initializing = true; this.loadError = false
          if (params.page === 1) { this.list = []; this.loading = false; if (this.$refs && this.$refs.scroll) this.$refs.scroll.reset() }
          try {
            const res = await apiStockListByCate(params)
            if (this.disposed || requestId !== this.requestId) return
            if (!res || !Array.isArray(res.data)) throw new Error('Invalid stock list')
            this.list = params.page === 1 ? res.data : this.list.concat(res.data)
            this.loading = res.total == null ? res.data.length > 0 : this.list.length < Number(res.total)
            this.loaded = true
          } catch (_) {
            if (!this.disposed && requestId === this.requestId) this.loadError = true
          } finally { if (requestId === this.requestId) this.initializing = false }
        },
        changeClass(idx){
      return 'flex-1 ' + quoteTone(idx)
        },
        onScroll(event){
          if (this.disposed || !this.marketPolling || event.target.clientHeight <= 0) return
          if(event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight-30 && this.loading && !this.initializing && !this.loadError){
            this.submitInfo.page++
            this.loading = false
            this.init()
          }
        }
      }

    }
</script>

<style lang="scss" scoped>
    .card-table-container {
		cursor: pointer;
        border-radius: 8px;
        width: 100%;
        min-width: 0;
        overflow: hidden;
        color: var(--theme-label);
        font-size: 14px;
        border: 1px ;
        background: var(--theme-bg);
        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: #eee;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #c1c1c1;
            border-radius: 8px;

            &:hover {
                background-color: #a8a8a8;
            }

            &:active {
                background-color: #787878;
            }
        }

        & {
            border-radius: 8px;
            scrollbar-width: thin;
            scrollbar-color: #c1c1c1 #eee;
        }
    }
    .flex-1{
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
    .height-31 {
        height: 31px;
        line-height: 31px;
    }
    .card-table-header{
      background: var(--theme-header);
    }
    .card-table-header,.card-table-body {
        padding: 0 11px;
    }
    .card-table-header {
      background: var(--theme-header);
      position: sticky;
      top: 0;
      z-index: 1;
    }
    .board-table-content { width: 1800px; min-width: 100%; }
    .card-table-header, .card-table-body li { display: grid; grid-template-columns: 50px repeat(15, minmax(0, 1fr)); }
    .card-table-body { margin: 0; list-style: none; }
    .card-table-header { box-sizing: border-box; }
</style>
